import BaseSender from './BaseSender';
import { PureComponent }  from 'react';
import PropTypes from 'prop-types';

class Top100Sender extends PureComponent {
  static propTypes = {
    /**
     * Название блока, которое будет отправляться в качестве ключа объекта,
     * передаваемого в вызов метода `window.top100Counter.sendCustomVars`.
     */
    blockName: PropTypes.string.isRequired,

    /** Событие, которое будет отправлятся по клику. */
    click: PropTypes.string,

    /** Событие, которое будет отправлятся при показе. */
    show: PropTypes.string,

    /**
     * По умолчанию событие отправляется только если клик сделан
     * по ссылке (`<a>`). Этот проп позволяет отключить проверку и
     * отправлять событие при клике по любому элементу.
     */
    skipTargetCheck: PropTypes.bool,
  };

  static defaultProps = {
    click: 'click',
    show: 'show',
  };

  send = (event) => {
    if (window.top100Counter) {
      window.top100Counter.sendCustomVars({ [this.props.blockName]: event });
    }
  };

  onShow = () => {
    this.send(this.props.show);
  };

  onClick = () => {
    this.send(this.props.click);
  };

  render() {
    const {
      /* eslint-disable no-unused-vars */
      blockName,
      /* eslint-enable no-unused-vars */
      children,
      show,
      click,
      ...otherProps
    } = this.props;

    return (
      <BaseSender
        onShow={show && this.onShow}
        onClick={click && this.onClick}
        {...otherProps}
      >
        {children}
      </BaseSender>
    );
  }
}

Top100Sender.displayName = 'Top100Sender';

export { Top100Sender as StorybookComponent };
export default Top100Sender;
